import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Footer() {
  const { t } = useTranslation();

  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            {/* HERAGAME */}
            <div className="col-xs-12 col-sm-6 col-md-3">
              <div className="header">
                <h3>{t("heragame")}</h3>
                <ul>
                  <li>
                    <Link to="/hakkimizda">{t("hakkimizda")}</Link>
                  </li>
                  <li>
                    <Link to="/bize-ulasin">{t("bizeUlasin")}</Link>
                  </li>
                  <li>
                    <Link to="/time-line">{t("timeLine")}</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* HESAP SAYFALARI */}
            <div className="col-xs-12 col-sm-6 col-md-3">
              <div className="header">
                <h3>{t("hesapSayfalari")}</h3>
                <ul>
                  <li>
                    <Link to="/register">{t("kayitOl")}</Link>
                  </li>
                  <li>
                    <Link to="/forgot-password">{t("sifremiUnuttum")}</Link>
                  </li>
                  <li>
                    <Link to="/odeme-gecmisi">{t("odemeGecmisi")}</Link>
                  </li>
                  <li>
                    <Link to="/user-cp#user-id">{t("promoKodKullan")}</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* DESTEK SAYFALARI */}
            <div className="col-xs-12 col-sm-6 col-md-3">
              <div className="header">
                <h3>{t("destekSayfalari")}</h3>
                <ul>
                  <li>
                    <Link to="/send-ticket">{t("ticketGonder")}</Link>
                  </li>
                  <li>
                    <Link to="/knowledge-bank">{t("bilgiBankasi")}</Link>
                  </li>
                  <li>
                    <Link to="/game-guide">{t("oyunRehberi")}</Link>
                  </li>
                  <li>
                    <Link to="/sss">{t("sikcaSorulanSorular")}</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* SÖZLEŞMELER */}
            <div className="col-xs-12 col-sm-6 col-md-3">
              <div className="header">
                <h3>{t("sozlesmeler")}</h3>
                <ul>
                  <li>
                    <Link to="/kullanici-sozlesmesi">
                      {t("kullaniciSozlesmesi")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/gizlilik-politikasi">
                      {t("gizlilikPolitikasi")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/davranis-kurallari">
                      {t("davranisKurallari")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/kvkk">{t("kvkkHakkinda")}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Buradaki partner ve diğer div'leri olduğu gibi bırakabiliriz */}
            <div className="col-xs-12 col-sm-3 col-md-3">
              <div className="partner hera-game">
                <a 
                  href="#!"
                  role="button"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                ></a>
              </div>
            </div>
            <div className="col-xs-12 col-sm-3 col-md-3">
              <div className="partner maxacs">
                <a 
                  href="#!"
                  role="button"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                ></a>
              </div>
            </div>
            <div className="col-xs-12 col-sm-3 col-md-3">
              <div className="partner klas-game">
                <a 
                  href="#!"
                  role="button"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                ></a>
              </div>
            </div>
            <div className="col-xs-12 col-sm-3 col-md-3">
              <div className="partner-2">
                <div className="dmca">
                  <a 
                    href="#!"
                    role="button"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  ></a>
                </div>
                <div className="ssl">
                  <a 
                    href="#!"
                    role="button"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  ></a>
                </div>
              </div>
            </div>

            <p>{t("footerText")}</p>
          </div>
        </div>
      </footer>

      <div className="divider rotate"></div>


    </>
  );
}

export default Footer;
